import type { Rect } from '../../../engine/hex/types';
import { IconRegistry } from '../../../ui/overlay/assets/IconRegistry';
import type { ModalTheme } from '../ModalTheme';
import type { HitTarget, MeasureResult, UiItem } from './Types';

export class ButtonItem implements UiItem {
    private rect: Rect = { x: 0, y: 0, w: 0, h: 0 };
    constructor(
        private id: string,
        private label: string,
        private enabled: boolean,
    ) {}

    measure(_ctx: CanvasRenderingContext2D, maxW: number, theme: ModalTheme): MeasureResult {
        return { w: Math.max(0, maxW), h: theme.button.height };
    }

    layout(x: number, y: number, w: number, theme: ModalTheme): void {
        this.rect = { x, y, w, h: theme.button.height };
    }

    draw(ctx: CanvasRenderingContext2D, theme: ModalTheme, _icons?: IconRegistry): void {
        ctx.lineWidth = 1;
        if (this.enabled) {
            ctx.fillStyle = theme.colors.buttonFill;
            ctx.strokeStyle = theme.colors.buttonStroke;
        } else {
            ctx.fillStyle = theme.colors.buttonFillDisabled;
            ctx.strokeStyle = theme.colors.buttonStrokeDisabled;
        }
        ctx.beginPath();
        ctx.rect(this.rect.x, this.rect.y, this.rect.w, this.rect.h);
        ctx.fill();
        ctx.stroke();

        ctx.font = theme.fonts.button;
        ctx.fillStyle = this.enabled ? theme.colors.buttonText : theme.colors.buttonTextDisabled;
        ctx.textBaseline = 'top';
        const textW = ctx.measureText(this.label).width;
        ctx.fillText(
            this.label,
            this.rect.x + (this.rect.w - textW) / 2,
            this.rect.y + theme.button.textOffsetY,
        );
    }

    collectHitTargets(out: HitTarget[], scrollY: number): void {
        out.push({
            id: this.id,
            enabled: this.enabled,
            rect: {
                x: this.rect.x,
                y: this.rect.y - scrollY,
                w: this.rect.w,
                h: this.rect.h,
            },
        });
    }
}
